/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Cognos Analytics Home
 *| (C) Copyright IBM Corp. 2020, 2021
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define({
	homePageTitleLabel: 'Kotisivu',
	myContent: 'Oma sisältö',
	teamContent: 'Työryhmän sisältö',
	folder: 'Kansio',
	files: 'Tiedostot',
	actionMenu: 'Toimintovalikko',
	myFolder: 'Omat kansiot',

	emptyFolderNoContent: 'Ei sisältöä',

	//EmptyStates
	emptyRecentTitle: 'Et ole tarkastellut sisältöä äskettäin.',
	emptyStateTitle: 'Aloita lisäämällä tietoja',
	emptyStateBody: 'Voit siirtää tietoja palvelimeen napsauttamalla edellä olevaa Siirrä tiedot -vaihtoehtoa tai vetämällä ja pudottamalla.',
	emptySearchResultTitle: 'Haku ei palauttanut tuloksia.',
	emptyPortalTitle: 'Portaaleja ei ole',
	emptyPortalBody: 'Portaaleja ei tällä hetkellä ole.',
	emptyWsProjectTitle: 'Aloita luomalla muistikirja Watson Studio -ohjelmassa.',
	emptyWsProjectBody: 'Kun palaat Cognos Analytics -ohjelmistoon, muistikirjasi näkyy tässä.',
	emptyFilteredResultTitle: 'Käytetyt suodattimet eivät palauttaneet tuloksia.',
	emptyDialogViewTitle: 'Kohteita ei ole',
	removeFromRecents: 'Poista viimeksi käytetyistä',

	// Welcome Banner
	welcomeBannerGreeting: 'Tervetuloa käyttämään Cognos Analytics -ohjelmistoa.',
	welcomeBannerDescription: 'Cognos Analytics tuo käyttöön tekoälyperusteisen itsepalveluanalytiikan. Katso, miten automaattisen tiedonvalmistelun, tiedon etsinnän ja visualisoinnin avulla voidaan tehdä entistä luotettavampia päätöksiä.',
	welcomeBannerDescription_trialUser: 'Voit aloittaa heti tutustumalla esittelyvideoon, tuotteen esittelykierrokseen ja Aloitusohjeet-välilehteen.',
	takeTourButtonLabel: 'Katso tuotteen esittelykierros',
	watchVideoButtonLabel: 'Katso video',
	// confirmation dialog
	hideWelcomeBannerMsg: 'Haluatko varmasti poistaa aloitusbannerin kotisivulta? Voit milloin tahansa ottaa sen uudelleen käyttöön profiilissa ja asetuksissa > Asetukset > Yleiset. ',
	hideWelcomeBannerTitle: 'Poista aloitusbanneri käytöstä',
	ok: 'OK',
	cancel: 'Peruuta',
	//howto video dialog
	modal_how_title: 'Opastusvideot',
	modal_overview_title: 'Katso Cognos Analytics -yleiskuvaus',
	modal_how_play: 'Toista video',
	modal_how_video_title_overview: 'Yleiskuvaus',
	modal_how_video_title_getStarted: 'Version 11.2 aloitusohjeet',
	modal_how_video_title_newUI: 'Tervetuloa tutustumaan uuteen Cognos-kokemukseen',
	modal_how_video_title_dataModule: 'Datamoduulien yleiskuvaus',
	modal_how_video_title_explore: 'Tietojen tutkimisen yleiskuvaus',
	modal_how_video_title_dashboard: 'Vuorovaikutteisten mittatietotaulujen yleiskuvaus',
	modal_how_video_title_reporting: 'Raportoinnin yleiskuvaus',
	modal_how_video_title_mobile: 'Cognosin tehot kämmenelläsi',

	// Toolbar
	search: 'Hae',
	addFolder: 'Lisää kansio',
	addLink: 'Lisää linkki',
	filter: 'Suodatin',
	sort: 'Lajittelu',
	settings: 'Asetukset',
	tilesView: 'Ruutunäkymä',
	listView: 'Luettelonäkymä',
	columnView: 'Sarakenäkymä',

	// Toolbar Actions
	sortBy: 'Lajitteluperuste',
	sortOrder: 'Järjestä',
	name: 'Nimi',
	modifiedTime: 'Muokattu',
	type: 'Tyyppi',
	ascending: 'Nouseva',
	descending: 'Laskeva',

	filterType: 'Tyyppi',
	filterModificationTime: 'Muokattu',
	all: 'Kaikki',
	today: 'Tänään',
	yesterday: 'Eilen',
	pastWeek: 'Viime viikko',
	pastMonth: 'Viime kuukausi',
	resetFilters: 'Palauta suodattimet',

	filterSearchPlaceHolder: 'Suodata avainsanojen mukaan',

	resetFilterTag: 'Palauta suodattimet valitsemalla X.',
	filterTagToolTip: 'Käytetyt suodattimet: %{appliedFilters}.',

	folderName: 'Kansion nimi',
	addAFolder: 'Lisää kansio',
	add: 'Lisää',
	error: 'Virhe',
	newFolderDefaultName: 'Uusi kansio',
	toastCreateNewFolder: 'Kansio %{nameOfFolder} on luotu kohteeseen %{tabName}.',
	folderAdded: 'Kansio on lisätty',
	refresh: 'Päivitä',
	openFolder: 'Avaa kansio',

	addAUrl: 'Lisää URL-osoite',
	linkName: 'URL-nimi',
	linkNamePlaceholder: 'Lisää URL-nimi',
	linkDescription: 'Kuvaus (valinnainen)',
	linkDescriptionPlaceholder: 'Lisää kuvaus',
	linkUri: 'URL-osoite',
	linkUriPlaceholder: 'Lisää URL-osoite, jossa on hyväksyttävä verkkoalue',
	acceptableDomains: 'Kelvolliset verkkoalueet',
	viewAcceptableDomains: 'Näytä kelvolliset verkkoalueet',
	mandatoryField: 'Pakollinen kenttä',
	linkAdded: 'URL-osoite on lisätty',
	toastCreateNewLink: 'Linkki %{nameOfLink} on lisätty kohteeseen %{tabName}.',
	noEntries: 'Kelvollisten verkkoalueiden luettelossa ei ole merkintöjä. Ota yhteys pääkäyttäjään.',

	compact: 'Tiivis',
	short: 'Lyhyt',
	default: 'Oletus',
	rowSize: 'Rivin koko',

	// GroupyByTypes
	folders: 'Kansiot',
	reports: 'Raportit',
	dashboards: 'Mittatietotaulut',
	data: 'Tiedot',
	packages: 'Paketit',
	explorations: 'Tutkimukset',
	stories: 'Tarinat',
	notebooks: 'Muistikirjat',
	others: 'Muut',

	// Error Messages
	itemsOverLimit: 'Määritetty nimi %{itemName} on pidempi kuin enimmäispituus (20 merkkiä). Jatka antamalla toinen nimi.',
	errorMessageLengthFolderName: 'Kirjoita kansion nimi, joka on enintään 255 merkin pituinen.',
	errorMessageLengthLinkName: 'Kirjoita linkin nimi, joka on enintään 255 merkin pituinen.',
	toastLaunchPerspectiveError: 'Kohteen %{objectType} avaus ei onnistu.',
	errorNoAccessTitle: 'Sinulla ei ole tämän sisällön käyttöoikeutta',
	errorNoAccessBody: 'Ota yhteys pääkäyttäjään tai katso lisätietoja seuraavasta linkistä:',
	errorEnableExternalContent: 'Ulkoisen sisällön käyttöönotto',

	//TableHeader
	lastModified: 'Viimeksi muokattu',
	location: 'Sijainti',
	tenant: 'Vuokralainen',

	// GetStartedTab
	getStartedLabel: 'Aloita IBM Cognos Analytics -tuotteen käyttö',
	learningHowToLabel: 'Oppimisresurssit',
	learningHowToDescription: 'Opi uutta ja saa apua liittymällä yhteisöön, lukemalla käyttöohjeita ja katsomalla videoita.',
	learningHowToActionLabel: 'Käynnistä ohjeruutu',
	howToVideosLabel: 'Opastusvideot',
	howToVideosDescription: 'Opettele käyttämään IBM Cognos Analytics -tuotetta, niin saat sen avulla esiin omiin tietoihisi liittyviä uusia oivalluksia.',
	howToVideosActionLabel: 'Katso videoita',
	acceleratorCatalogLabel: 'Accelerator-luettelo',
	acceleratorCatalogDescription: 'Selaa jatkuvasti kasvavaa luetteloa muun muassa toimialaan liittyvistä käyttötiedoista, parhaiden käytäntöjen oppaista ja mukautetuista visualisoinneista.',
	acceleratorCatalogActionLabel: 'Selaa luetteloa',
	sampleSectionTitle: 'Mallit',
	sampleSectionDescription: 'Kokeile esimerkkejä, jotka näyttävät, mitä kaikkea Cognos Analytics -tuotteella on tarjota.',
	// Samples Section
	createDashboardSampleTitle: 'Ensimmäisen mittatietotaulun luonti',
	createDashboardSampleDescription: 'Aloita analytiikkamatka Cognos-mittatietotaulujen avulla.',
	covid19SampleTitle: 'COVID-mittatietotaulu',
	covid19SampleDescription: 'Tämä COVID-19-tietoja analysoiva Cognos-mittatietotaulu ja mukautetut laajennukset esittelevät tuotteen huimia mahdollisuuksia.',
	sankeySampleTitle: 'Sankey',
	sankeySampleDescription: 'Laajenna visualisointikirjastoasi mukautetuilla visualisoinneilla, kuten Sankey-kaaviolla.',
	viewAllSamplesActionLabel: 'Näytä kaikki mallit',
	byFeatureTitle: 'Ominaisuuden mukaan',
	byFeatureDescription: 'Voit selata malleja ominaisuuden mukaan, esimerkiksi seuraavien: ydintoiminnot, mukautetut ohjausobjektit, laajennukset, muistikirjat ja suhteelliset päivämäärät.',
	byIndustryTitle: 'Toimialan mukaan',
	byIndustryDescription: 'Voit selata malleja toimialan mukaan, esimerkiksi autoteollisuuden tai pankkitoiminnan perusteella.',
	// SamplesTab
	sampleTabTitle: 'Hae inspiraatiota valmiista malleista',
	sampleTabLabel: 'Accelerator-luettelossa voit tutustua lisämalleihin ja -laajennuksiin, joiden tekijöinä ovat IBM, kumppanit ja asiakkaat',

	// quickLaunch
	quickLaunchLabel: 'Pika-aloitus',
	expand: 'Laajenna',
	collapse: 'Tiivistä',

	// quickLaunch dialog
	quickLaunchModalLabel: 'Aloita valitsemalla mitä haluat luoda.',

	// contentPageView
	contentPageTitleLabel: 'Sisältö',
	uploadFile: 'Siirrä tiedot',
	new: 'Uusi',
	create: 'Luo',
	more: 'Enemmän',

	// open dialog
	selectDataSourcesToAdd: 'Valitse lisättävät tietolähteet.',
	openDialogDefaultTitle: 'Avaa',

	// save dialog
	save: 'Tallenna',
	saveAs: 'Tallenna nimellä',
	saving: 'Tallennetaan...',
	selectedDestination: 'Valittu kohde: %{nameOfFolder}',
	toastDuplicateFileDifferentType: '%{nameOfItem} on jo määritetty, mutta sen laji on toinen. Valitse toinen nimi.',
	confirmOverwriteTitle: 'Vahvista nykyisten tietojen korvaus',
	confirmOverwriteMsg: 'Järjestelmässä on jo tiedosto %{nameOfFile}. Haluatko korvata sen tiedot valitun tiedoston sisältämillä tiedoilla?',

	// copy move dialog
	copy: 'Kopioi',
	move: 'Siirrä',
	copyOrMove: 'Kopioi tai siirrä: ',
	copyOnly: 'Kopioi ',
	createShortcut: 'Luo pikakuvake',
	createShortcutDialogTitle: 'Luo pikakuvake: ',

	// External asset types
	wsProject: 'Watson Studio -projekti',
	externalContentTypeWs: 'Watson Studio',

	// Asset Types
	package: 'Paketti',
	dataModule: 'Datamoduuli',
	exploration: 'Tutkimus',
	mode: 'Tila',
	live: 'Päivittyvä',
	snapshot: 'Tilannevedos',
	noSnapshotsFound: 'Tilannevedosta ei löydy',
	uploadedFile: 'Siirretty tiedosto',
	fileUpload: 'Siirrä tiedot',
	dataSetEx: 'Tietojoukko',
	externalRepository: 'Ulkoinen tietosäilö',
	queryMode: 'Kyselytila',
	queryModeCompatible: 'Yhteensopiva',
	queryModeDynamic: 'Dynaaminen',
	report: 'Raportti',
	activeReport: 'Aktiivinen raportti',
	query: 'Kysely',
	analysis: 'Analyysi',
	dashboard: 'Mittatietotaulu',
	dashboardTemplate: 'Mittatietotaulun malli',
	jupyterNotebook: 'Muistikirja',
	wsNotebook: 'Watson Studio -muistikirja',
	jupyter: 'Jupyter',
	ws: 'Watson Studio',
	story: 'Tarina',
	workspace: 'Työtila',
	pagelet: 'Sivu',
	content: 'Sisältö',
	directory: 'Nimitilat',
	dataSet: 'Tietojoukko',
	powerPlayCube: 'PowerPlay-kuutio',
	powerPlayReport: 'PowerPlay-raportti',
	powerPlay8Report: 'PowerPlay-raportti',
	powerPlay8ReportView: 'PowerPlay-raporttinäkymä',
	reportTemplate: 'Raporttimalli',
	packageConfigurations: 'Paketin kokoonpanon määritys',
	agent: 'Agentti',
	agentDefinition: 'Agentin määritys',
	agentDefinitionView: 'Agenttinäkymä',
	dataMovementTask: 'Datasiirtotehtävä',
	dataMovementTaskAlias: 'Datasiirtotehtävän valenimi',
	document: 'Asiakirja',
	DocumentRetention: 'Asiakirjan ominaisuudet',
	jobDefinition: 'Työn määritykset',
	job: 'Työ',
	metricsDataSourceETLTask: 'Mittatietojen tietolähteen ETL-tehtävä',
	metricsExportTask: 'Mittatietojen vientitehtävä',
	metricsFileImportTask: 'Mittatietotiedoston tuontitehtävä',
	metricsMaintenanceTask: 'Mittatietojen ylläpitotehtävä',
	planningTask: 'Suunnittelutehtävä',
	shortcut: 'Pikakuvake',
	URL: 'URL-osoite',
	launchable: 'Aloitettava',
	dataSetFolder: 'Tietojoukon kansio',
	ViewAccessibleLabel: 'Näytä %{label}',
	overrideReportOptions: 'Ohita raportin oletusasetukset',
	formats: 'Muodot',
	saveReport: 'Tallenna raportti',
	promptForValues: 'Kysy',
	reportView: 'Raporttinäkymä',
	html: 'html',
	pdf: 'pdf',
	spreadsheetML: 'Excel',
	xlsxData: 'Excel-tiedot',
	csv: 'csv',
	xml: 'xml',
	txt: 'txt',
	//Details
	details: 'Tiedot',
	open: 'Avaa',
	created: 'Luotu',
	modified: 'Muokattu',
	owner: 'Omistaja',
	dataSource: 'Tietolähde',
	share: 'Määritä yhteiskäyttöön',
	addToFavorites: 'Lisää suosikkeihin',
	properties: 'Ominaisuudet',
	detailsEmptyStateBody: 'Näet kohteen tiedot valitsemalla sen',
	editNameAndDescription: 'Muokkaa nimeä ja kuvausta',
	none: 'Ei mitään',

	//rename dialog
	nameInvalid: 'Nimi on virheellinen',
	namePlaceholder: 'Anna nimi',
	description: 'Kuvaus',
	descriptionInvalid: 'Kuvauksen maksimipituus on 350 merkkiä.',
	descriptionPlaceholder: 'Anna kuvaus',
	errorMessageApostropheError: 'Anna tiedoston nimi, jossa ei ole sekä merkkiä \' että merkkiä "',
	renameCollisionError: '%{name} on jo käytössä. Anna toinen nimi.',
	unknownRenameError: 'Objektin nimeäminen uudelleen epäonnistui. Pyydä lisäohjeita pääkäyttäjältä.',

	//types
	xls: 'xls',
	xlsx: 'xlsx',

	unableToOpenFolderMsg: 'Määritetyn kansion avaaminen ei onnistu.',

	//Upload
	uploadToFolder: "Siirrä kohteeseen <span class=\"homeUploadFolder\"><span id=\"homeUploadFolderName\">%{folderName}{launchAction}</span></span>",
	uploadAndLaunch: "Siirrä kohteeseen <span class=\"homeUploadFolder\"><span id=\"homeUploadFolderName\">%{folderName}</span></span> ja käynnistä%{launchAction}",
	quickUpload: "Pikasiirto",
	quickUploadAndLaunch: "Siirrä tiedostoja kohteeseen <span class=\"homeUploadFolder\"><span id=\"homeUploadFolderName\">%{folderName}</span></span> vetämällä ja pudottamalla ne, ja avaa tiedostot johonkin seuraavista tiloista.",
	unsupportedFilesSingle: "Tiedostoa %{files} ei ole siirretty, koska se on virheellinen pika-aloitusta varten.",
	unsupportedFilesMultiple: "Tiedostoja ei ole siirretty, koska kaikkien valitsemiesi tiedostojen pitää olla kelvollisia pika-aloitusta varten.",
	unsupportedFilesSingleInvalid: "%{files} on virheellinen.",
	unsupportedFilesMultipleInvalid: "%{files} tiedostoa ei kelpaa.",
	supportedFileTypes: "Vain seuraavat tiedostotyypit ovat sallittuja: %{extensions}.",
	uploadDragAndDrop: "Vedä ja pudota",
	uploadDragAndDropMessage: "Vedä ja pudota tiedosto tähän ja siirrä se kohteeseen <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span>",

	// searchBar
	searchWasSaved: 'Hakuehdot %{searchTerm} on tallennettu.',
	searchWasntSaved: 'Hakuehtoja %{searchTerm} ei ole tallennettu.',
	searchSuggestions: 'Ehdotukset',
	savedSearch: 'Tallennetut haut',
	searchWasDeleted: 'Hakuehdot %{searchTerm} on poistettu.',
	searchWasntDeleted: 'Hakuehtoja %{searchTerm} ei ole poistettu.',
	savedBarTitle: 'Cognos Analytics -haku',
	searchContentPageTitle: 'Hae',
	searchContentPageTitleLabel: 'Näkyvissä ovat seuraavan kohteen tulokset: %{searchTerm}',
	showingSearchRsult: 'Näkyvissä %{resultCount} kohdetta',
	saveSearch: 'Tallenna haku',
	saveTenSearches: 'Voit tallentaa 10 hakua.',
	deleteASearch: 'Poista yksi, jotta voit tallentaa toisen.',
	close: 'Sulje',

	//recent view
	recents: 'Uusin',
	noAccessRecent: 'Ei käyttöoikeutta',
	noAccessRecentMsg: 'Sinulla ei ole tämän omaisuuden käyttöoikeutta. Käyttöoikeus on ehkä poistettu käytöstä, poistettu kokonaan tai käyttöoikeutta on ehkä muutettu. Vahvista omaisuuden tila ja sen odotettu lähdesijainti. Voit poistaa omaisuuden uusimmista kohteista napsauttamalla OK-painiketta.',
	noAccessMsg: 'Sinulla ei ole tämän omaisuuden käyttöoikeutta. Käyttöoikeus on ehkä poistettu käytöstä, poistettu kokonaan tai käyttöoikeutta on ehkä muutettu.',

	//contextToolbar
	itemsSelected: 'Valittu %{nameOfSelection} kohdetta',
	itemSelected: 'Valittu %{nameOfSelection} kohde'

});